module.exports = __webpack_public_path__ + "media/components/src/assets/images/text_type_2-1b4c9fe4d1342ce6636e3b8f898ee25e.jpg";